import { Cache } from "memory-cache";
import { CharacterWalletTransactionEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCharacterWalletTransactionEntity(
  transaction_id: number
): Promise<CharacterWalletTransactionEntity | null> {
  let entity: any = await cache.get(transaction_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCharacterWalletTransactionEntity(transaction: CharacterWalletTransactionEntity) {
  cache.put(transaction.props.transaction_id.toString(), transaction, 60 * 60 * 1000 /* 1 hour */);
}
